import axios from "@/libs/http";


/**
 * 发送验证码
 */
export const sendVerifyCode = (clerkApplyId, mobile, regionCode) => {
  let data = new URLSearchParams();
  data.append("clerkApplyId", clerkApplyId)
  data.append("mobile", mobile)
  data.append("regionCode", regionCode)
  return axios.request({
    url: '/s/clerkApply/sendVerifyCode',
    data,
    method: 'post'
  })
}

/**
 * 验证验证码并做进一步处理
 */
export const checkedMobile = (clerkApplyId, mobile, regionCode, verifyCode) => {
  let data = new URLSearchParams()
  data.append("clerkApplyId", clerkApplyId)
  data.append("mobile", mobile)
  data.append("regionCode", regionCode)
  data.append("verifyCode", verifyCode)
  return axios.request({
    url: '/s/clerkApply/checkedMobile',
    data,
    method: 'post'
  })
}

export const getClerkApply = (clerkApplyId) => {
  return axios.request({
    url: '/s/clerkApply/getClerkApply',
    params: {
      clerkApplyId: clerkApplyId
    },
    method: 'get'
  })
}
